module.exports = __webpack_public_path__ + "static/media/footer-email-Icon.e0045d87.svg";